import { Model } from '../decorators/model.decorator';
import { Column } from '../decorators/column.decorator';
import { BaseModel } from './base.model';

@Model('vdmoServer')
export class VdmoServer extends BaseModel {
  @Column()
  host: string | undefined
}
